import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProductAttributeDefinitionsComponent } from '@src/app/features/product-attribute-definitions/product-attribute-definitions/product-attribute-definitions.component';
import { AddProductAttributeDefinitionsComponent } from '@src/app/features/product-attribute-definitions/add-product-attribute-definitions/add-product-attribute-definitions.component';
import { EditProductAttributeDefinitionsComponent } from '@src/app/features/product-attribute-definitions/edit-product-attribute-definitions/edit-product-attribute-definitions.component';
import { ViewProductAttributeDefinitionsComponent } from '@src/app/features/product-attribute-definitions/view-product-attribute-definitions/view-product-attribute-definitions.component';

const routes: Routes = [
  { path: '', component: ProductAttributeDefinitionsComponent },
  { path: 'add', component: AddProductAttributeDefinitionsComponent },
  { path: ':productAttributesDefinitionId/edit', component: EditProductAttributeDefinitionsComponent },
  { path: ':productAttributesDefinitionId', component: ViewProductAttributeDefinitionsComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductAttributeDefinitionsRoutingModule { }
